/**
 * VendorProductMediaService
 * Service for managing vendor product media
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product media CRUD operations with product-specific queries
 */
export class VendorProductMediaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductMediaService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all media for a specific product
     * @param productId - Product ID
     * @returns Array of vendor product media views
     */
    async getByProduct(productId) {
        const response = await this.getByProductRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all media for a specific product with full response
     * @param productId - Product ID
     * @returns ResponseData with array of vendor product media views
     */
    getByProductRaw(productId) {
        const url = this.buildUrl(`product/${productId}`);
        return this.http.get(url);
    }
}
VendorProductMediaService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductMediaService.BASE_PATH = 'api/vendor-product-media';
//# sourceMappingURL=VendorProductMediaService.js.map